import React from "react"
import { useTheme } from "styled-components"

import ImagePreload from "components/image-preload"
import { Container, ImageComponent } from "./styles"

const SIZE_TO_PERCENT = {
  Large: 0.75,
  Medium: 0.5,
  Small: 0.25,
}

/**
 * An image component that is either full-width or centered with three sizes
 * (small - 25%, medium - 50% and large - 75% width). When centered on mobile,
 * the width is always 100% with side padding.
 */
const Image = ({
  id,
  elRef,
  cloudinaryUrls,
  aspectRatios,
  cappedHeight,
  fullWidth,
  size,
  hideOnMobile,
  hideOnPageLoad,
  dataExpId,
  ...props
}) => {
  const theme = useTheme()

  const widthFull = fullWidth ? 1440 : Math.round(SIZE_TO_PERCENT[size] * 1440)
  const heightFull = cappedHeight ? 750 : Math.round(widthFull * aspectRatios.desktop)

  const widthTablet = fullWidth ? 1024 : Math.round(SIZE_TO_PERCENT[size] * 1024)
  const heightTablet = cappedHeight ? 750 : Math.round(widthTablet * aspectRatios.tablet)

  const widthMobile = 500
  const heightMobile = Math.round(widthMobile * aspectRatios.mobile)

  const images = [
    {
      screenSize: 1024,
      url: cloudinaryUrls.desktop,
      transforms: `c_fill,g_auto,w_${widthFull},h_${heightFull},q_auto,f_auto,fl_lossy`,
    },
    {
      screenSize: 768,
      url: cloudinaryUrls.tablet,
      transforms: `c_fill,g_auto,w_${widthTablet},h_${heightTablet},q_auto,f_auto,fl_lossy`,
    },
    {
      url: cloudinaryUrls.mobile,
      transforms: `c_fill,g_auto,w_${widthMobile},h_${heightMobile},q_auto,f_auto,fl_lossy`,
    },
  ]

  return (
    <Container
      id={id}
      ref={elRef}
      fullWidth={fullWidth}
      size={size}
      hideOnMobile={hideOnMobile}
      data-exp-id={dataExpId}
      hideOnPageLoad={hideOnPageLoad}
    >
      {theme.component.onTop && <ImagePreload images={images} />}
      <ImageComponent
        aspectRatios={aspectRatios}
        height={cappedHeight ? 750 : undefined}
        images={images}
        lazy={!theme.component.onTop}
        {...props}
      />
    </Container>
  )
}

export default Image
